<template>
  <div
    v-if="!props.payload?.content || props.payload?.content.length === 0"
    :class="classes"
    v-html="props.payload?.rendered"
  />
  <div
    v-else-if="props.payload?.content && props.payload?.content.length > 0"
    :class="classes"
  >
    <DefaultArticlesArtObject
      v-for="(content, index) in props.payload?.content"
      :key="`${props.parentIdent}-bold-${index}`"
      :type="content?.type"
      :payload="content"
      :parent-ident="`${props.parentIdent}|bold-${index}`"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  payload: { type: Object, required: false },
  parentIdent: { type: String, required: false },
})

const classes = computed(() => [
  'ao__bold',
  { 'ao__bold--brand-color': props.payload?.attributes?.brand_color },
])
</script>
